import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useLocation } from '@reach/router'
import { useWindowSize } from '@reach/window-size'

import ArrowIcon from '_assets/icons/arrow-right-24-px.svg'
import { assignmentShape } from '_utils/proptypes'
import { MOBILE_THRESHOLD } from '_config/media-queries'
import AssignmentLight from '_components/assignment-light'

import styles from './styles.css'

const MOBILE_HEADER_SIZE = 72
const HEADER_SIZE = 80
const DESKTOP_OFFSET = 80

const CourseSectionLight = ({
  className,
  titleClassName,
  assignmentClassName,
  assignmentsWrapperClassName,
  title,
  assignments,
  isInstructor,
  onStartMeeting,
  isLeaderLed,
  isStartingCall,
  enableAssignmentVideoCall,
}) => {
  const { state } = useLocation()
  const { width } = useWindowSize()
  const [isOpen, setIsOpen] = useState(true)

  useEffect(() => {
    if (state?.scrollTo) {
      const element = document.getElementById(`assignment-${state.scrollTo}`)

      if (element) {
        const { top } = element.getBoundingClientRect()

        const headerSize =
          width <= MOBILE_THRESHOLD ? MOBILE_HEADER_SIZE : HEADER_SIZE + DESKTOP_OFFSET

        const slicePosition = top + window.scrollY - headerSize

        window.scrollTo({
          top: slicePosition,
          behavior: 'smooth',
        })
      }
    }
  }, [state, width])

  const onToggleSection = () => {
    setIsOpen(prev => !prev)
  }

  return (
    <div className={classnames(styles.container, className)}>
      <h2 className="visually-hidden">{title}</h2>
      <button onClick={onToggleSection} className={styles.button} type="button">
        <span className={classnames(styles.title, titleClassName)}>{title}</span>{' '}
        <svg
          className={classnames(styles['arrow-icon'], { [styles.open]: isOpen })}
          viewBox={ArrowIcon.viewBox}
          aria-hidden="true"
        >
          <use xlinkHref={`#${ArrowIcon.id}`} />
        </svg>
      </button>
      {isOpen && (
        <div className={classnames(styles.assignments, assignmentsWrapperClassName)}>
          {assignments.map(assignment => (
            <AssignmentLight
              content={assignment}
              className={assignmentClassName}
              key={assignment.id}
              isInstructor={isInstructor}
              onStartMeetingClick={onStartMeeting}
              isLeaderLed={isLeaderLed}
              isStartingCall={isStartingCall}
              enableAssignmentVideoCall={enableAssignmentVideoCall}
              cardId={`assignment-${assignment.id}`}
            />
          ))}
        </div>
      )}
    </div>
  )
}

CourseSectionLight.propTypes = {
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  assignmentClassName: PropTypes.string,
  assignmentsWrapperClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  assignments: PropTypes.arrayOf(assignmentShape).isRequired,
  isInstructor: PropTypes.bool,
  onStartMeeting: PropTypes.func,
  isLeaderLed: PropTypes.bool,
  isStartingCall: PropTypes.bool,
  enableAssignmentVideoCall: PropTypes.func,
}

CourseSectionLight.defaultProps = {
  className: '',
  titleClassName: '',
  assignmentClassName: '',
  assignmentsWrapperClassName: '',
  isInstructor: false,
  onStartMeeting: () => {},
  isLeaderLed: false,
  isStartingCall: false,
  enableAssignmentVideoCall: () => {},
}

export default React.memo(CourseSectionLight)
